import React, { useState, useEffect, useRef } from "react";
import { CHAT_DEMO } from "@/data";

/* Chat mockup animado de la landing */
export default function ChatDemo() {
  const [shown, setShown] = useState(1);
  const bodyRef = useRef(null);
  useEffect(() => {
    if (shown >= CHAT_DEMO.length) return;
    const t = setTimeout(() => setShown((s) => s + 1), 1800);
    return () => clearTimeout(t);
  }, [shown]);
  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [shown]);
  return (
    <div className="chat-demo" aria-label="Vista previa del chat de la comunidad" data-testid="chat-demo">
      <div className="chat-head">
        <span className="live" /><b>#general — Comunidad Liberti</b><span>2.847 en línea</span>
      </div>
      <div className="chat-body" ref={bodyRef}>
        {CHAT_DEMO.slice(0, shown).map((m, i) => (
          <div className={`msg ${m.bot ? "bot" : ""}`} key={i}>
            <div className="av">{m.av}</div>
            <div className="bub"><b>{m.who}</b>{m.txt}</div>
          </div>
        ))}
      </div>
      <div className="chat-input">
        <input placeholder="Únete para escribir en el chat…" disabled />
        <button className="btn btn-gold btn-sm" style={{ pointerEvents: "none" }}>Enviar</button>
      </div>
    </div>
  );
}
